'use client'

import Link from 'next/link'
import Navbar from '../../components/Navbar'

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-cream text-ink">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-serif text-3xl sm:text-4xl font-semibold tracking-tight text-ink mb-6">Privacy Policy (Deeliver)</h1>
        <div className="prose prose-sm max-w-none text-gray-800">
          <p>
            Deeliver is committed to respecting your privacy. This Privacy Policy explains what information we
            collect from users and how we use, share, and protect that information. By using the Deeliver
            service, you agree to the practices described in this policy.
          </p>
          <h2>Information We Collect</h2>
          <p>
            We collect information that you provide to us directly when using Deeliver. This includes basic contact
            details (such as your name, email address, and phone number) and delivery information (like the pickup
            address, the drop-off address at UT Austin, and requested delivery times). If you create an account, we
            may also collect login information (like a username and password). Additionally, when you make a payment
            for a delivery, we collect necessary payment information (for example, your credit card or payment method
            details). Note: For security, payment details are processed by our trusted payment processor – we do not store
            your full credit card numbers on our own servers.
          </p>
          <h2>How We Use Information</h2>
          <p>
            We use your information to provide and improve our service. Primarily, this means using your contact and
            delivery details to schedule and fulfill the meal delivery. For example, we use the pickup and drop-off
            information to coordinate with a driver and ensure your meal goes to the right place at the right time. We
            also use your phone number and/or email to send you updates or notifications about your delivery status
            (such as confirming a driver assignment, ETA updates, or delivery completion). Payment information is used to
            securely process the fees for your deliveries. We may also use your info to communicate with you if you reach
            out with questions, or to send important service-related announcements. We do not use your personal data for
            any unrelated marketing purposes at this MVP stage (and we won’t spam you).
          </p>
          <h2>Information Sharing</h2>
          <p>
            Deeliver only shares your information in limited ways in order to run the service. We share the necessary
            details with the driver who is delivering your meal — for instance, the driver will receive the pickup address,
            drop-off address, and your contact phone number (so they can call/text if needed during delivery). We also
            rely on a few third-party service providers to operate Deeliver. For example, we may use an SMS or email
            service to send delivery updates, and a payment processing service to handle credit card transactions. These
            providers will get only the information required to perform their functions. Aside from drivers and these
            service partners, we do not sell or rent your personal information and we don’t share it with any outside
            parties for their own marketing. The only other scenario where we might disclose information is if we are
            required by law to do so or need to protect the rights and safety of our users or others.
          </p>
          <h2>Data Deletion (Your Rights)</h2>
          <p>
            You have the right to request deletion of your personal information from Deeliver. If you would like us to remove
            your data, please contact us (see “Contact Us” below). Upon such a request, we will delete the personal
            information we have about you from our active systems, except any data we are required to keep for legal,
            security, or operational reasons. Please note that if you delete your data or account, you will not be able to use
            the Deeliver service unless you sign up again with new information.
          </p>
          <h2>Data Security</h2>
          <p>
            We take reasonable measures to protect your personal information. Our website and databases use standard
            security practices to guard against unauthorized access or misuse of your data. However, no Internet or email
            transmission is ever completely secure or error-free, so we cannot guarantee absolute security. We encourage
            you to use a strong password and take precautions when using the service.
          </p>
          <h2>Policy Updates</h2>
          <p>
            As a new and evolving service, Deeliver may update this Privacy Policy from time to time. If we make significant
            changes, we will notify users by posting the updated policy on our site (and updating the “last modified” date at
            the top). We encourage you to check this page periodically for any changes. Continued use of the service after a
            policy update constitutes your acceptance of the changes.
          </p>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, or if you would like to review, update, or delete your
            personal information, please contact us at <a href="mailto:deeliveradmin@gmail.com">deeliveradmin@gmail.com</a>. You may also write to us at:
            Deeliver, 8301 Broken Branch Drive, Round Rock, Texas 78681.
          </p>
          <p className="mt-6">
            <Link href="/register" className="text-ember underline hover:text-ember-hover">
              Back to registration
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}


